import { render } from "./App.vue?vue&type=template&id=0fa5891c&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=0fa5891c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0fa5891c"

export default script